module.exports = __webpack_public_path__ + "img/computer-app-technology.9970256c.svg";